<template>
  <Panel :isLoading="isLoading">
    <h2 slot="title">{{ tableData.length }} Active Outbreak(s) <div style="display: flex; margin-left:auto;align-items:center;gap: 0.5rem">
        30 Days
        <el-switch v-model="useNinetyDays" on-color="#333" off-color="#333" on-text="" off-text=""></el-switch>
        90 Days
      </div></h2>
    <el-table :data="tableData">
      <el-table-column label="Scope" prop="scope"></el-table-column>
      <el-table-column v-if="this.$configStore.data.sites.length > 1" label="Facility" prop="facility"></el-table-column>
      <el-table-column label="Infection Site" prop="typeValue"></el-table-column>
      <el-table-column label="Cases Linked" prop="totalCases"></el-table-column>
      <el-table-column label="Declared Date" prop="declared"></el-table-column>
    </el-table>
  </Panel>
</template>

<script>
import moment from "moment";
import Panel from "./Panel.vue";

export default {
  name: "ActiveOutbreaks",
  props: ["filters"],
  watch: {
    filters() {
      this.getOutbreaks();
    },
    useNinetyDays() {
      this.getOutbreaks();
    }
  },
  components: {
    Panel
  },
  data() {
    return {
      isLoading: true,
      useNinetyDays: true,
      tableData: []
    };
  },
  methods: {
    async getOutbreaks() {
      this.isLoading = true;
      const filters = {
        ...this.filters,
        declaredDateRangeStart: moment()
          .subtract(this.useNinetyDays ? 90 : 30, "days")
          .startOf("day")
          .toDate()
          .toISOString(),
        declaredDateRangeEnd: moment()
          .endOf("day")
          .toDate()
          .toISOString(),
        resolved: false,
        page: 1,
        size: 10
      };
      if (!filters.unitIds.length) {
        delete filters.unitIds;
      }
      const response = await this.$http.post(`${window.CONFIG.om_api}/search`, filters).then(resp => resp.json());
      this.tableData = response.content.map(r => {
        return {
          ...r,
          scope: `${r.scope} - ${r.scopeDetail.join(', ')}`,
          facility: this.$configStore.data.sites.filter(s => s.id === r.facId).map(s => s.displayText)[0],
          declared: moment.utc(r.declaredDate).format(this.$configStore.dateFormat())
        };
      });
      this.isLoading = false;
    }
  }
};
</script>

<style scoped></style>
